<template>
  <div class="flex flex-col card nico-device-info">
    <div class="flex flex-row items-center justify-between" >
      <DeviceName
          :show-edit="showEdit"
          :device-name="deviceInfo.deviceName"
          :device-id="deviceInfo.tagId"
          :legal="legal"
          align="flex-start"
          @onUpdateDeviceName="onUpdateDeviceName"/>
      <div class="flex flex-1 flex-row items-center gap-2 justify-end">
        <div
            v-if="!deviceInfo.isItEmpty" class="radius-border vertical items-center justify-center" style="width:36px;height:36px"
            @click="onFavoriteDevice">
          <van-image
              :src="deviceInfo.isFavorite === 1 ? require('@/assets/icons/consumer/ic_favorite_device_like.svg'): require('@/assets/icons/consumer/ic_favorite_device.svg')"/>
        </div>
        <div class="radius-border  vertical items-center justify-center" style="width:36px;height:36px" v-if="false">
          <van-image :src="require('@/assets/icons/consumer/ic_share_device.svg')" @click="onShare"/>
        </div>

      </div>
    </div>


    <div class="horizontal  w-full" v-if="legal">

      <div class="vertical flex-1 items-center justify-center main-color text-12px">
        <van-image :src="deviceInfo.flavorPicture" fit="contain" height="151px"/>

      </div>

      <div class="mt-1 nico-info-wrap vertical items-center justify-center text-12px" style="flex:1.2">
        <div class="" v-if="deviceInfo.deviceType === 7">
          Atomizer Connections:<span>{{ deviceInfo.currentSeconds }}</span>
        </div>
        <div v-else>
          Flavor:{{ deviceInfo.flavorName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeviceName from "@/components/home/DeviceName.vue";

export default {
  name: "NicoDeviceInfo",
  components: { DeviceName },
  props: {
    legal: {
      type: Boolean,
      default: true
    },
    showEdit: {
      type: Boolean,
      default: false
    },
    deviceInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    onUpdateDeviceName(content) {
      this.$emit("onUpdateDeviceName", content);
    },
    onFavoriteDevice() {
      this.$emit("onFavoriteDevice");
    },
    onShare() {
      if (navigator.canShare()) {
        navigator.share(
            {
              title: "webShare",
              text: "webShare",
              url: location.href
            }
        );
      } else {
        this.$toast({
          message: "no support share"
        });
      }
    }
  }
};
</script>


<style scoped lang="less">
.flavor {
  width: 112px;
  height: 25px;
  border-radius: 6px;
  background: #F1F6FF;
  font-size: 12px;
  line-height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ingredient {
  max-width: 112px;
  font-size: 10px
}

.nico-info-wrap {
  font-size: 12px;
  height:131px;
  color: #333333;
  text-align: center;

  border-radius: 12px;
  background-color: #f6f6f6;
}

.nico-device-info {

}
</style>